<template>
<div class="col-lg-12">
    <div class="row">
        <div class="col-lg-4">
            <div class="form-group">
                <label>ค้นหาวันที่ส่งพัสดุ (วันเริ่มต้น - วันสุดท้าย)</label>
                <date-range-picker
                    class="w-100"
                    :opens="'center'"
                    :singleDatePicker="false"
                    :appendToBody="true"
                    :ranges="false"
                    :closeOnEsc="false"
                    :autoApply="true"
                    :locale-data="{ format: 'dd/mm/yyyy' }"
                    v-model="date"
                    @update="onChangeDate"
                >
                </date-range-picker>
            </div>
        </div>
        <div class="col-lg-2" v-if="role.isShippop || role.isSuperadmin">
            <div class="form-group">
                <label>ค้นหาร้านค้า</label>
                <v-select
                    :options="shops"
                    class="custom-dropdown--sm"
                    label="name"
                    placeholder="ค้นหาร้านค้า"
                    v-model="filters.selectedShop"
                    :reduce="selectedShop => selectedShop.id"
                    :class="{ 'is-invalid bd-danger': $v.filters.selectedShop.$error }"
                    taggable
                ></v-select>
                <div
                    v-if="$v.filters.selectedShop.$error"
                    class="invalid-feedback d-block"
                >
                    กรุณาเลือกร้านค้า
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label>ค้นหาขนส่ง</label>
                <b-form-select v-model="filters.key" :options="options"></b-form-select>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label>ค้นหา</label>
                <div>
                    <button class="btn btn-info" @click="onClick()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end col-lg">
            <b-form-group label="Export File" class="mb-0 pb-2">
                <div 
                    class="btn-group btn-sm-res btn-export" 
                    role="group" 
                    aria-label="Basic example">
                    <ExportExcel 
                        :columns="fields" 
                        :getData="onExport"
                        name="สรุปยอด DROPOFF"
                        :disabled="false"
                    >
                    </ExportExcel>
                    <b-button 
                        variant="info btn-sm-res" 
                        @click="$htmlToPaper('tablePrint')"
                    >
                    print
                    </b-button>
                </div>
            </b-form-group>
        </div>
    </div>
</div>
</template>
<script>
import columns from './js/columns'
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import moment from 'moment'
import { required, numeric } from "vuelidate/lib/validators"
const DATE_NOW = moment().format("YYYY-MM-DD")
export default {
    name: 'ToolBox',
    components:{
        ExportExcel
    },
    props:{
        services:{
            type: Array,
            default: []
        },
        filters:{
            type: Object,
            default: {
                startDate: DATE_NOW,
                endDate: DATE_NOW,
                key: false,
                selectedShop: false,
                limit: 1000
            }
        },
        shops:{
            type: Array,
            default: []
        },
        orders:{
            type: Object,
            default: {
                data: [],
                current_page: 1,
                per_page: 0,
                total_item: 0,
                limit: 20
            }
        },
        onSubmit: Function
    },
    mounted(){
        // console.log( this.$ADDITIONAL_SERVICE.dropoff )
    },
    data(){
        return {
            filter: {},
            selected: false,
            date: {
                startDate: DATE_NOW,
                endDate: DATE_NOW
            },
            role: this.$USER_LOGIN.get()
        }
    },
    validations(){
        let results = {}
        if( !this.role.isShippop && !this.role.isSuperadmin )return results
        results.filters = {
            selectedShop: { required, numeric }
        }
        return results
    },
    methods:{
        onChangeDate( date ){
            this.filters.startDate = date.startDate
            this.filters.endDate = date.endDate
        },
        async onClick(){
            this.$v.$touch()
            if( this.$v.$invalid )return false
            try{
                this.setLimitPage( 20 )
                const get = await this.onSubmit()
                this.setOrder( get.data )
            }catch( err ){
                alert( 'เกิดข้อผิดพลาด' )
                console.log( this.$options.name, err )
            }
        },
        async onExport(){
            const limit = 10000
            if( this.orders.total_item < 1 ){
                alert( 'กรุณาค้นหารายการที่ต้องการ export' )
                return false
            }else if ( this.orders.total_item > limit ){
                alert( `สามารถ export รายการได้ไม่เกิน ${limit} ชิ้น` )
                return false
            }
            try{
                const preCurrentPage = this.orders.current_page
                this.setLimitPage( limit )
                this.setCurrentPage(1)
                const get = await this.onSubmit()
                this.setLimitPage()
                this.setCurrentPage(preCurrentPage)
                return get.data.data
            }catch( err ){
                alert( 'เกิดข้อผิดพลาด' )
                console.log( this.$options.name, err )
            }

        },
        setLimitPage( limit = 20 ){
            this.orders.limit = limit
            return limit
        },
        setCurrentPage(page){
            this.orders.current_page = page
            return page
        },
        setOrder( results ){
            this.orders.current_page = results.current_page
            this.orders.per_page = results.per_page
            this.orders.total_item = results.total_item
            this.orders.data = results.data
        },
    },
    computed:{
        options(){
            let response = []
            if( this.services.length > 0 ){
                response = this.services.reduce( (results, service) => {
                    results.push({
                        value: service.key,
                        text: service.name
                    })
                    return results
                }, [])
            }
            return [ {value: false, text: 'ดูทั้งหมด'}, ...response ]
        },
        fields(){
            let cols = columns.filter( col => col.key !== 'index' )
            if( this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin )
            return cols
            else return cols.filter( col => col.key !== 'shop_name' )
        }
    }
}
</script>